<script lang="ts">
  export let onClose: () => void;
</script>

<button on:pointerup={onClose} class="activity-badge-clickable-overlay" />
<img
  class="activity-badge-backdrop"
  alt="activity-badge-backdrop"
  src={`${__PUBLIC_PATH__}images/zare.svg`}
/>

<style>
  .activity-badge-clickable-overlay {
    all: unset;
    z-index: 300;
    width: 100%;
    height: 85%;
    position: absolute;
    top: 0;
    left: 0;
    cursor: pointer;
  }

  .activity-badge-backdrop {
    z-index: 10;
    width: 100%;
    height: 100%;
    background-color: hsla(208, 42%, 17%, 0.8);
    position: fixed;
    object-fit: cover;
    left: 0;
    top: 0;
  }
</style>
